import apiClient from "./apiClient";

function filenameFromContentDisposition(disposition, fallback) {
  if (!disposition) return fallback;
  const match = /filename\*?=(?:UTF-8'')?"?([^"]+)"?/i.exec(disposition);
  if (!match) return fallback;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
}

const hbAnalyticsApi = {
  getHbHraAnalyticsByCompany: async (companyId, filters = {}) => {
    const response = await apiClient.get(`/analytics/hb/hra/${companyId}`, {
      params: filters
    });
    return response.data;
  },

  getHbStressAnalyticsByCompany: async (companyId, filters = {}) => {
    const response = await apiClient.get(`/analytics/hb/stress/${companyId}`, {
      params: filters
    });
    return response.data;
  },

  getHbHraGlobalAnalytics: async (filters = {}) => {
    const response = await apiClient.get(`/analytics/global/hb/hra`, {
      params: filters
    });
    return response.data;
  },

  getHbStressGlobalAnalytics: async (filters = {}) => {
    const response = await apiClient.get(`/analytics/global/hb/stress`, {
      params: filters
    });
    return response.data;
  },

  getHbGlobalRespondants: async (filters = {}) => {
    const response = await apiClient.get(`/analytics/global/hb/respondants`, {
      params: filters
    });
    return response.data.respondants || [];
  },

  getHbRespondantsByCompanyId: async (companyId) => {
    const response = await apiClient.get(`/analytics/hb/${companyId}/respondants`);
    return response.data.respondants || [];
  },

  getHbRespondantsByCompanyIdExport: async (companyId) => {
    const response = await apiClient.get(
      `/analytics/hb/${companyId}/respondants/export`,
      {
        responseType: "blob",
        headers: {
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
      }
    );

    const filename = filenameFromContentDisposition(
      response.headers["content-disposition"],
      `hb-respondants-${companyId}.xlsx`
    );

    return { blob: response.data, filename };
  },

  downloadHbRespondantsByCompanyIdExcel: async (companyId) => {
    const { blob, filename } =
      await hbAnalyticsApi.getHbRespondantsByCompanyIdExport(companyId);

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || `hb-respondants-${companyId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
};

export default hbAnalyticsApi;
